import React from 'react'
import { Spinner } from 'react-bootstrap'
import PropTypes from 'prop-types';

export const SkuLoader = ({ message }: any) => {
    return (
        <div className="align-items-center justify-content-center d-flex flex-column">
            <div>
                <h5 className="text-primary text-center mt-4">{message}</h5>
            </div>
            <div className="mt-4 p-4 justify-content-center">
                <Spinner animation="grow" variant="primary" />
                {/* <Spinner animation="grow" variant="primary" />
                <Spinner animation="grow" variant="primary" />
                <Spinner animation="grow" variant="primary" /> */}
            </div>
        </div>
    )
}

SkuLoader.propTypes = {
    message: PropTypes.string
}
